import { useCallback } from 'react';

const useDownloadTemplate = (filePath: string, fileName: string): (() => void) => {
  const downloadFile = useCallback(() => {
    const link = document.createElement('a');
    link.href = filePath; 
    link.download = fileName;
    link.click();
  }, [filePath, fileName]);

  return downloadFile;
};

export default useDownloadTemplate;
